import React from 'react'
import { NavLink } from 'react-router-dom';
import Logo from './images/logoimg.jpeg';
import './css/Navbar.css'
const NavbarForProductList = () => {
    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-light bg-light">
                <a href="" className="navbar-brand">
                    <img src={Logo} width="80" height="80" class="d-inline-block align-top" alt=""/>
                </a>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <NavLink className="nav block mt-4 lg:inline-block lg:mt-0 text-teal-200 hover:text-white mr-4" to="/">Home</NavLink>
                    <NavLink className="nav block mt-4 lg:inline-block lg:mt-0 text-teal-200 hover:text-white mr-4" to="/product_list">Product</NavLink>
                    <NavLink className="nav block mt-4 lg:inline-block lg:mt-0 text-teal-200 hover:text-white mr-4" to="/download">Download</NavLink>
                    <NavLink className="nav block mt-4 lg:inline-block lg:mt-0 text-teal-200 hover:text-white mr-4" to="/connect">Connect</NavLink>
                    <NavLink className="nav block mt-4 lg:inline-block lg:mt-0 text-teal-200 hover:text-white mr-4" to="/#">Order</NavLink>
                    <form className="form-inline mx-20 my-lg-0">
                        <input className="search-in-nav form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search" />
                    </form>
                </div>
            </nav>
        </>
    )
}

export default NavbarForProductList;